import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layouts'

import me from './modules/me'
import ranking from './modules/ranking'
import homeChildren from './modules/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/gamelist',
    redirect: 'gamelist/90001',
    component: () => import('@/views/video/gamelist'),
    meta: {
      defaultParams: { id: 90005 },
      title: 'gamelist',
      keepAlive: false,
    },
  },
  {
    path: '/:id?',
    name: 'xglt',
    component: () => import('@/views/xglt/home.vue'),
    meta: {
      defaultParams: { id: 90005 },
      title: 'xglt',
      keepAlive: false,
    },
  },
  {
    path: '/live/:id?',
    name: 'live',
    component: () => import('@/views/xglt/live.vue'),
    meta: {
      defaultParams: { id: 90005 },
      title: 'live',
      keepAlive: false,
    },
  },
  {
    path: '/contactus/:id?',
    name: 'contactus',
    component: () => import('@/views/xglt/contactus.vue'),
    meta: {
      defaultParams: { id: 90005 },
      title: 'contactus',
      keepAlive: false,
    },
  },
  {
    path: '/aboutus/:id?',
    name: 'aboutus',
    component: () => import('@/views/xglt/aboutus.vue'),
    meta: {
      defaultParams: { id: 90005 },
      title: 'aboutus',
      keepAlive: false,
    },
  },
  {
    path: '/home',
    //redirect: 'home',
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home'),
        meta: {
          title: '首页',
          keepAlive: false,
        },
      },
      {
        path: 'home2',
        name: 'Home2',
        component: () => import('@/views/home2'),
        meta: {
          title: '首页',
          keepAlive: false,
        },
      },
      {
        path: 'find',
        name: 'Find',
        component: () => import('@/views/find'),
        meta: {
          title: '发现',
          keepAlive: false,
        },
      },
      {
        path: 'platform',
        name: 'Platform',
        component: () => import('@/views/platform'),
        meta: {
          title: '平台',
          keepAlive: false,
        },
      },
      {
        path: 'my',
        name: 'My',
        component: () => import('@/views/my'),
        meta: {
          title: '我的',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/api',
    name: 'Api',
    component: () => import('@/views/home/api'),
    meta: {
      title: 'api',
      keepAlive: false,
    },
  },

  {  //新增页面。展示4个彩种
    path: '/indexcs',
    name: 'Indexcs',
    component: () => import('@/views/home/indexcs'),
    meta: {
      title: 'indexcs',
      keepAlive: false,
    },
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: {
      title: '登陆',
      keepAlive: false,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register'),
    meta: {
      title: '注册',
      keepAlive: false,
    },
  },

  ...me,
  ...ranking,
  ...homeChildren,
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
    }
  }


})

export default router
